import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDarkMessageIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6.25 7.7207H11.25V9.2207H6.25V7.7207Z",
			fill: "#DFE2E7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 15.75H13V17.25H18V15.75Z",
			fill: "#DFE2E7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13 13.25H18V14.75H13V13.25Z",
			fill: "#DFE2E7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 18H9.5V16H11.5V14.5H9.5V12.5H8V14.5H6V16H8V18Z",
			fill: "#DFE2E7"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.5003 9.54L14.0903 10.95L13.0303 9.89L14.4403 8.47L13.0303 7.06L14.0903 6L15.5003 7.41L16.9103 6L17.9703 7.06L16.5603 8.47L17.9703 9.89L16.9103 10.95L15.5003 9.54Z",
			fill: "#DFE2E7"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5 3H19C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3ZM5 19H19V5H5V19Z",
			fill: "#DFE2E7"
		})
	]
});
export default SvgDarkMessageIcon;
